module.exports = __webpack_public_path__ + "static/media/kids-class-2.fb4cceed.jpeg";